import { Component } from 'vue';
import type { UserModule } from '../types';

export interface MatchProps {
    value: string | number;
}

export const Match: Component<MatchProps> = {
    props: ['value'],
    setup() {
        return (a: any) => {
            const children = a.$slots.default();
            const c = children.find((v: any) => {
                if (!(v.props && v.props.values)) {
                    return false;
                }
                return v.props.values.some((i: any) => i === a.value);
            });

            if (c) {
                return c;
            }

            const f = children.find((v: any) => {
                return v.props?.fallback === '';
            });

            if (f) {
                return [f];
            }

            return [];
        };
    }
};

export interface PattProps {
    values: (string | number)[];
    fallback?: boolean;
}

export const Patt: Component<PattProps> = {
    props: {
        values: {
            default: []
        },
        fallback: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        return (a: any) => {
            if (a.$slots.default) {
                return a.$slots.default();
            }
            return [];
        };
    }
};

export const install: UserModule = ({ app }) => {
    app.component('Match', Match);
    app.component('Patt', Patt);
};
